import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=d1b2fcb0&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=d1b2fcb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b2fcb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1b2fcb0')) {
      api.createRecord('d1b2fcb0', component.options)
    } else {
      api.reload('d1b2fcb0', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=d1b2fcb0&scoped=true&", function () {
      api.rerender('d1b2fcb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zbk7CPKHE1II/JS/comp/PopupBox.vue"
export default component.exports